export default __webpack_public_path__ + "static/33-c92aeb368437eb20f76fa30b311677dc.jpg";